import http from "../../utils/http-common";
import { useQuery } from "@tanstack/react-query";
import type { ServiceProcedure } from "../../interfaces";

export function useServiceProcedure() {
  const getServiceProcedure = async (): Promise<ServiceProcedure[]> => {
    const response = await http.get<ServiceProcedure[]>("/service_procedure");
    return response.data;
  };

  return useQuery<ServiceProcedure[]>({
    queryKey: ["service_procedure"],
    queryFn: getServiceProcedure,
  });
}
